"use client";

import React, { useEffect, useState } from "react";
// import Image from "next/image";
import Lottie from "lottie-react";
import loaderJSON from "@/utils/ParaaLoader.json";

const cryptoQuotes = [
  "Cryptocurrency is such a powerful concept that it can almost overturn governments. - Charles Lee, Creator of Litecoin",
  "Bitcoin is the beginning of something great: a currency without a government. - Peter Thiel",
  "The blockchain is the financial challenge of our time. It is going to change the way that our financial world operates. - Blythe Masters",
  "You can’t stop things like Bitcoin. It will be everywhere, and the world will have to readjust. - John McAfee",
  "Blockchain technology is going to change everything, from banking to government to our identities. - Abigail Johnson",
  "Bitcoin is the most important invention in the history of the world since the Internet. - Roger Ver",
  "In the future, instead of having banks, we will have one universal ledger that everyone has access to. - Vitalik Buterin",
  "Blockchain is the biggest opportunity set we can think of over the next decade or so. - Bob Greifeld",
  "Fiat is no different from Monopoly money. The only difference is that it has the backing of the government. - Max Keiser",
  "Bitcoin is a remarkable cryptographic achievement. The ability to create something that is not duplicable in the digital world has enormous value. - Eric Schmidt",
  "Ethereum is the forefather of decentralized applications, and it will change the way we use the internet. - Gavin Wood",
  "We see Bitcoin as potentially the greatest social network of all. - Tyler Winklevoss, Co-founder of Winklevoss Capital Management",
];

const Loader: React.FC = () => {
  const [quoteIndex, setQuoteIndex] = useState(() =>
    Math.floor(Math.random() * cryptoQuotes?.length)
  );
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setQuoteIndex((prevIndex) => (prevIndex + 1) % cryptoQuotes.length);
        setFade(false);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex justify-center items-center w-full h-full top-0 left-0 fixed bg-[#10151dd7] z-50 font-satoshi">
      <div className="flex flex-col items-center justify-center gap-y-2">
        {/* // <svg
        //   aria-hidden="true"
        //   className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-black"
        //   viewBox="0 0 100 101"
        //   fill="none"
        //   xmlns="http://www.w3.org/2000/svg"
        // >
        //   <path
        //     d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        //     fill="currentColor"
        //   />
        //   <path
        //     d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        //     fill="currentFill"
        //   />
        // </svg> */}

        {/* <div className="animate-pulse">
          <Image 
onContextMenu={(e) => e.preventDefault()}
            src="/assets/logos/logo.png"
            alt="Logo"
            width={98}
            height={38}
            className="transition-transform duration-500 ease-in-out transform scale-100 hover:scale-110"
          />
        </div> */}
        <div className="w-40 h-40">
          <Lottie animationData={loaderJSON} loop={true} />
        </div>
        <span
          className={`text-white text-center font-medium text-base max-w-[400px] sm:max-w-[600px] transition-opacity duration-500 ${
            fade ? "opacity-0" : "opacity-100"
          }`}
        >
          {cryptoQuotes[quoteIndex]}
        </span>
      </div>
    </div>
  );
};

export default Loader;
